import React, { useState } from 'react';
import mobileMenu from "../medias/mobileMenu.png";
import { IoIosCloseCircleOutline } from 'react-icons/io';

const MoblieHeaderFbAd = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div>
      <img
        onClick={() => setIsOpen(!isOpen)}
        className="md:hidden block cursor-pointer"
        src={mobileMenu}
        alt=""
      />
      <div
        className={`fixed top-0 right-0 bg-gradient-to-b from-[#19344D] to-[#3B79B3] text-white max-w-96 w-full z-50 h-full transform transition-all duration-500 ease-in-out ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="mb-4 px-6 pt-6 flex items-center justify-between">
          <h2 className="opacity-60 text-[16px] uppercase">Navigation</h2>
          <button className="text-[35px]" onClick={() => setIsOpen(false)}>
            <IoIosCloseCircleOutline />
          </button>
        </div>
        <div className="h-[1px] w-full bg-gray-500 mt-4" />
        <div className="px-6 pt-4">
          <a
            href="https://customsync.app/login?signup=true"
            className="inline-block cursor-pointer text-white bg-[#F29E13] px-6 py-3 rounded-lg font-bold orange-button"
            onClick={() => setIsOpen(false)}
          >
            Start Your Free Trial
          </a>
        </div>
      </div>
    </div>
  );
};

export default MoblieHeaderFbAd;
